import React from 'react'
import { ToastContainer } from 'react-toastify'
import PurchaseWindowFull from './components/PurchaseWindowFull'
import PurchaseWindowCompact from './components/PurchaseWindowCompact'
import { PurchaseProvider } from './contexts/PurchaseContext'

import './styles/purchase.css'
import './styles/purchase-window.css'
import './styles/product-select.css'
import './styles/slick-carousel.css'
import './styles/subscription-select.css'
import './styles/collection-select.css'
import './styles/upsell.css'

type Props = {
  appType: string,
  isLegacy: boolean
}

export default function AppFull({appType, isLegacy} : Props) {
  const purchaseWindow = appType == 'full' ? <PurchaseWindowFull isLegacy={isLegacy} /> : <PurchaseWindowCompact />

  return (
    <div>
        <PurchaseProvider appType={appType} isLegacy={isLegacy}>
          {purchaseWindow}
        </PurchaseProvider>
        <ToastContainer />
    </div>
  )
}
